import React, { useEffect, useRef} from 'react';
import useLocalAudioToggle from '../../hooks/useLocalAudioToggle';
import { Logger } from '../../utils';
import useVideoContext from '../../hooks/useVideoContext';
import useRoomState from '../../hooks/useRoomState';
import { useTwilioAppState } from '../../state';
import { CONSUMER } from '../../constants';


export default function ToggleAudioButton(props) {
    const [isAudioEnabled, toggleAudioEnabled] = useLocalAudioToggle();
    const toggleCount = useRef(0);
    const roomState = useRoomState();
    const isReconnecting = roomState === 'reconnecting';
    const { source } = useTwilioAppState();
    const enableVirtualWaitingRoom = window && window.serverData && window.serverData.data ? window.serverData.data.enableVirtualWaitingRoom : false;

    const { localTracks, isPublishingTracks, isAcquiringLocalTracks } = useVideoContext();
    const audioTrack = localTracks.find(track => track.kind === 'audio');

    const audioBtnClick = () => {
        Logger(`UI.Twilio.Room.Audio.${isAudioEnabled ? "Mute" : "Unmute"}.Clicked`, new Date());
        toggleAudioEnabled();
    };

    useEffect(() => {
        if (enableVirtualWaitingRoom && source === CONSUMER) {
            if (props.showWaitingMsg && !isReconnecting && !isAcquiringLocalTracks && !isPublishingTracks && audioTrack && toggleCount.current !== 1) {
                toggleAudioEnabled();
                toggleCount.current = 1;
            }
            else if (!props.showWaitingMsg && audioTrack && toggleCount.current == 1) {
                toggleAudioEnabled();
                toggleCount.current = 2;
            }
        }
    }, [props.showWaitingMsg, audioTrack, isPublishingTracks, isAcquiringLocalTracks, isReconnecting,enableVirtualWaitingRoom]);

    return (
        <React.Fragment>
            <button type="button" className={`btn${props.disabled ? " disabled-style" : ""}`} disabled={props.disabled} onClick={audioBtnClick} id="mute-audio"><span className={`${isAudioEnabled ? " icon-mic" : " icon-mic-off"}`} /></button>
        </React.Fragment>
    );
}
